/* eslint-disable react-hooks/exhaustive-deps */
import {
  EyeOutlined,
  FolderOpenOutlined,
  FormOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Form,
  Modal,
  Radio,
  Row,
  Space,
  Switch,
  Tag,
  Tooltip
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import TableAndFilters from '../../components/TableAndFilters';
import UserContext from '../../context/user-context';
import { errorHandler, ESTADOS_AUTORIZACION, toUpperCase } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { fieldTypes, filterConditions } from '../../utils/filter-utils';

const AutorizacionList = () => {
  const { user } = useContext(UserContext);
  const [columns, setColumns] = useState([]);
  const tableRef = useRef();
  const [historico, setHistorico] = useState(false);
  const [mode, setMode] = useState('todos');
  const [showComentario, setShowComentario] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comentarioDet, setComentarioDet] = useState('');
  const [token, setToken] = useState(null);
  const [archivar, setArchivar] = useState(false);
  const history = useHistory();

  const columnasComunes = [
    {
      title: 'Autorización Flujo',
      dataIndex: 'id',
      filterType: fieldTypes.NUMERIC,
      sortable: true,
      width: '2%'
    },
    {
      title: 'Flujo',
      render: (_, record) => {
        if (record.id_solicitud) {
          return 'SOLICITUD';
        }
        if (record.id_cotizacion) {
          return 'COTIZACIÓN';
        }
        return '';
      }
    },
    {
      title: 'Empresa',
      filterType: fieldTypes.STRING,
      render: (_, record) => {
        return record.empresa.nombre_corto.toUpperCase();
      }
    },
    {
      title: 'Aseguradora',
      dataIndex: ['aseguradora', 'descripcion'],
      filterType: fieldTypes.STRING
    },
    {
      title: 'Producto',
      render: (_, record) => {
        if (record.id_solicitud) {
          return record.solicitud.cotizacion.producto.descripcion;
        }
        if (record.id_cotizacion) {
          return record.cotizacion.producto.descripcion;
        }
        return '';
      }
    },
    {
      title: 'Descripción',
      render: (_, record) => {
        if (record.id_solicitud) {
          return record.solicitud.cotizacion.persona.nombres;
        }
        if (record.id_cotizacion) {
          return record.cotizacion.persona.nombres;
        }
        return '';
      }
    },
    {
      title: 'Comentario',
      dataIndex: 'comentario'
    },
    {
      title: 'Fecha Creacion',
      dataIndex: 'fecha',
      filterType: fieldTypes.DATETIME,
      sortable: true,
      render: (_, record) => {
        return record.fecha
          ? moment(record.fecha).format('DD/MM/YYYY HH:mm')
          : 'Sin fecha';
      }
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      render: (estado) => {
        const estadoUpperCase = toUpperCase(estado);
        let color = 'white';
        if (estadoUpperCase === 'PENDIENTE') {
          color = 'yellow';
        } else if (estadoUpperCase === 'APROBADO') {
          color = 'green';
        } else if (estadoUpperCase === 'RECHAZADO') {
          color = 'red';
        } else if (estadoUpperCase === 'ARCHIVADO') {
          color = 'lightgray';
        } else if (estadoUpperCase === 'APROBADO PARCIALMENTE') {
          color = 'green';
        }
        return (
          <Tag color={color} key={estadoUpperCase}>
            {estadoUpperCase}
          </Tag>
        );
      },
      filterType: fieldTypes.ENUM,
      filters: Object.keys(ESTADOS_AUTORIZACION).map((key) => ({
        text: ESTADOS_AUTORIZACION[key],
        value: key
      })),
      sortable: true
    },
    {
      title: 'Estado General',
      dataIndex: 'estado_general'
    },
    {
      title: 'Acciones',
      key: 'action',
      align: 'left',
      render: (text, record) => {
        return (
          <Space size="small">
            <div
              style={{
                visibility: getVisibility(record.estado)
              }}
            >
              <Tooltip title="Consultar">
                <Button
                  type="text"
                  icon={<EyeOutlined />}
                  size="middle"
                  onClick={() =>
                    handleOpenUrl(`/autorizaciones/${record.token}/view`)
                  }
                />
              </Tooltip>
            </div>
            <div
              style={{
                visibility: condicionesDeRevision(record) ? '' : 'hidden'
              }}
            >
              <Tooltip title="Revisar/Consultar">
                <Button
                  type="text"
                  icon={<FormOutlined />}
                  size="middle"
                  onClick={() =>
                    handleOpenUrl(`/autorizaciones/${record.token}`)
                  }
                />
              </Tooltip>
            </div>
            <div
              style={{
                visibility: setDisabled(record)
              }}
            >
              <Tooltip title="Archivar">
                <Button
                  type="text"
                  icon={<FolderOpenOutlined />}
                  size="middle"
                  onClick={() => {
                    setToken(record.token);
                    setIsModalOpen(true);
                  }}
                />
              </Tooltip>
            </div>
          </Space>
        );
      }
    }
  ];

  const setDisabled = (autorizacionFlujo) => {
    if (autorizacionFlujo.estado === 'PENDIENTE') {
      // Admin Segu
      if (user && user['cognito:groups'][0] === 'ADMIN') {
        return '';
      }
      // Admin Empresa
      if (user && user['cognito:groups'][0] === 'ADMIN_EMPRESA') {
        return '';
      }

      // Admin Sucursal del Ejecutivo que generó
      if (user && user['cognito:groups'][0] === 'ADMIN_SUCURSAL') {
        return '';
      }

      // Ejecutivo que generó
      if (
        autorizacionFlujo &&
        autorizacionFlujo.ejecutivo &&
        user &&
        autorizacionFlujo.ejecutivo.id_cognito === user.sub
      ) {
        return '';
      }
    }
    return 'hidden';
  };

  const getVisibility = (estado) => {
    if (user && user['cognito:groups'][0] === 'ADMIN') {
      return '';
    }
    if (estado === 'PENDIENTE') {
      return 'hidden';
    }
    return '';
  };

  const condicionesDeRevision = (autorizacionFlujo) => {
    if (autorizacionFlujo.estado.includes('PENDIENTE')) {
      return true;
    }

    return false;
  };

  const onChange = async () => {
    setHistorico(!historico);
  };

  const toArchive = async () => {
    try {
      await instanceRef.instance.post(`/autorizacion/archive/${token}`, {
        comentario: comentarioDet
      });
      setArchivar(true);
    } catch (err) {
      errorHandler(err, err.message);
    }
  };

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  useEffect(() => {
    setHistorico(...[historico]);
    let columnas = [];
    columnas = [...columnasComunes];
    setColumns(columnas);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const Tabla = useCallback(() => {
    const defaultFilters = {};
    defaultFilters.estado = {
      value: 'PENDIENTE',
      filterType: fieldTypes.STRING,
      filterCondition: historico
        ? filterConditions.NOT_EQUALS
        : filterConditions.EQUALS
    };
    if (mode !== 'todos') {
      defaultFilters.id_solicitud = {
        value: 'null',
        filterType: fieldTypes.STRING,
        filterCondition:
          mode === 'solicitud'
            ? filterConditions.NOT_EQUALS
            : filterConditions.EQUALS
      };
    }
    return (
      <TableAndFilters
        withGeneralFilter
        ref={tableRef}
        url="/autorizacion"
        title="Autorizaciones"
        columns={columns}
        defaultFilters={defaultFilters}
        showTable
        tableLayout="unset"
        hasExportar={false}
      />
    );
  }, [columns, historico, mode, archivar]);

  return (
    <ResponsiveContainer size="large" style={{ paddingTop: 0 }}>
      <Card style={{ marginBottom: 5, textAlign: 'left' }} title="Filtros">
        <Form
          scrollToFirstError
          layout="horizontal"
          name="historico"
          autoComplete="off"
        >
          <Row justify="start">
            <Col lg={3} md={3} xs={24}>
              <Form.Item
                label="Histórico"
                name="historico"
                valuePropName="checked"
                style={{ margin: 'initial' }}
              >
                <Switch onChange={onChange} />
              </Form.Item>
            </Col>
            <Col lg={6} md={6} xs={24}>
              <Radio.Group
                onChange={(e) => {
                  setMode(e.target.value);
                }}
                value={mode}
                style={{
                  marginBottom: 8
                }}
              >
                <Radio.Button value="todos">Todos</Radio.Button>
                <Radio.Button value="solicitud">Solicitud</Radio.Button>
                <Radio.Button value="cotizacion">Cotización</Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
        </Form>
      </Card>
      <Tabla />
      <Modal
        title="Archivar Autorización"
        open={isModalOpen}
        onOk={() => {
          toArchive();
          setIsModalOpen(false);
        }}
        okText="Confirmar"
        onCancel={() => {
          setIsModalOpen(false);
        }}
      >
        <Row>
          <Col xs={24}>
            <p>
              ¿Desea agregar un comentario?
              <Switch
                checked={showComentario}
                onChange={(value) => {
                  setShowComentario(value);
                }}
                style={{ marginLeft: '10px' }}
              />
            </p>
          </Col>
          <Col xs={24}>
            {showComentario && (
              <TextArea
                placeholder="Escribir comentario"
                value={comentarioDet}
                rows={4}
                onChange={(e) => {
                  setComentarioDet(e.target.value);
                }}
              />
            )}
          </Col>
        </Row>
      </Modal>
    </ResponsiveContainer>
  );
};

export default AutorizacionList;
